module.exports = __webpack_public_path__ + "img/plus-icon.75afada5.svg";